// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t9-2";
export var container = "_t9-4";
export var dismissButton = "_t9-3";
export var hasPaddingBottom = "_t9-6";
export var last = "_t9-e";
export var scrollbarThumb = "_t9-c";
export var scrollbarTrack = "_t9-b";
export var selected = "_t9-9";
export var spin = "_t9-1";
export var spinning = "_t9-0";
export var suggestionItem = "_t9-d";
export var suggestionsPanel = "_t9-5";
export var tonePill = "_t9-8";
export var tonesContainer = "_t9-7";
export var unselected = "_t9-a";